import { useRef } from 'react';

function useDebounceFunc(delay: number): (func: () => void) => void {
  const timeout = useRef<NodeJS.Timeout | null>(null);

  return (func: () => void) => {
    if (timeout.current) {
      clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {
        func();
      }, delay);
    } else {
      timeout.current = setTimeout(() => {
        func();
      }, delay);
    }
  };
}

export { useDebounceFunc };
